<template>
  <div class="app-container">
    <div class="filter-container">
      <template v-if="user.user.type === 'admin'">
        <el-select class="filter-item" multiple collapse-tags filterable v-model="listQuery.school_ids" placeholder="所属学校" style="width: 300px" clearable>
          <el-option v-for="item in schools" :key="item.id" :label="item.school_name" :value="item.id">
          </el-option>
        </el-select>
      </template>

      <template v-if="user.user.type !== 'shop' && user.user.type !== 'admin'">
        <el-select class="filter-item" multiple collapse-tags filterable v-model="listQuery.shop_ids" placeholder="所属店铺" style="width: 300px" clearable>
          <el-option v-for="item in shops" :key="item.id" :label="item.shop_name" :value="item.id">
          </el-option>
        </el-select>
      </template>

      <el-date-picker class="filter-item" style="display: inline-flex;" v-model="dateArr" type="daterange" value-format="yyyy-MM-dd" unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :picker-options="pickerOptions"></el-date-picker>
      <el-button class="filter-item" type="primary" @click="handleFilter">搜索</el-button>
    </div>

    <div v-loading="listLoading">
      <el-row :gutter="20">
        <el-col :sm="6">
          <el-card class="box-card">
            <div class="value">{{ data.total_num || 0 }}</div>
            <div class="subtitle">总订单数</div>
          </el-card>
        </el-col>
        <el-col :sm="6">
          <el-card class="box-card">
            <div class="value">{{ data.yesterday_turnover_rate || 0 }}%</div>
            <div class="subtitle">昨天营业额增长率</div>
          </el-card>
        </el-col>
        <el-col :sm="6">
          <el-card class="box-card">
            <div class="value">{{ data.last_week_turnover_rate || 0 }}%</div>
            <div class="subtitle">上周营业额增长率</div>
          </el-card>
        </el-col>
        <el-col :sm="6">
          <el-card class="box-card">
            <div class="value">{{ data.last_month_turnover_rate || 0 }}%</div>
            <div class="subtitle">上月营业额增长率</div>
          </el-card>
        </el-col>
      </el-row>

      <!-- 折线图 -->
<!--      <ChartOrderTurnover style="margin-top: 30px;" :data="data.order_turnover"></ChartOrderTurnover>-->
      <!-- 折线图 -->
    </div>
  </div>
</template>

<script>
  import ChartOrderTurnover from '@/components/ChartOrderTurnover'
  import request from "@/utils/request";
  import {mapGetters} from "vuex";
  var moment = require("moment");

  export default {
    components: {
      ChartOrderTurnover,
    },
    data() {
      return {
        shops: [],
        listLoading:false,
        dateArr: null,
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        listQuery: {
          school_ids: [],
          shop_ids: [],
          start_time: "",
          end_time: "",
        },
        data: [],
      };
    },
    created() {
      this.getShopList();
      // 默认近七天数据
      this.listQuery.start_time = moment().subtract(7, 'days').format("YYYY-MM-DD");
      this.listQuery.end_time = moment().format("YYYY-MM-DD");
      this.dateArr = [this.listQuery.start_time, this.listQuery.end_time];
      this.getList();
    },
    computed: {
      ...mapGetters(["schools", "school_id","user"])
    },
    watch: {
      dateArr(newVal, oldVal) {
        if (newVal) {
          this.listQuery.start_time = newVal[0] + ' 00:00:00';
          this.listQuery.end_time = newVal[1] + ' 23:59:59';
        } else {
          this.listQuery.start_time = "";
          this.listQuery.end_time = "";
        }
      },
      school_id(newVal, oldVal) {
        this.listQuery.school_id = newVal;
        this.getList();
        this.getShopList();
      },
    },
    methods: {
      getList() {
        this.listLoading = true
        return request({
          url: "/api/backend/finance/turnoverRate",
          method: "post",
          data: this.listQuery
        }).then(res => {
          this.data = res.data;
          this.listLoading = false
        });
      },
      getShopList() {
        request({
          url: "/api/backend/shop/list",
          method: "get",
          params: {
            page: 1,
            limit: 1000000,
            school_id: this.school_id,
          }
        }).then(response => {
          this.shops = response.data.data;
        });
      },
      handleFilter() {
        if(!this.listQuery.start_time || !this.listQuery.end_time){
          this.$message.warning('请选择开始和结束日期')
          return
        }
        this.getList();
      },
    }
  };
</script>

<style lang="scss" scoped>
  .box-card {
    text-align: center;
    .value {
      color: #546DFE;
      font-weight: bold;
      font-size: 26px;
    }
    .subtitle {
      font-size: 12px;
      color: gray;
      margin-top: 6px;
    }
  }
</style>
